export default ({
  state: {
    MainFormDialog: {
      icon: '',
      identity: '',
      with: 600,
      dialog: false,
      title: '',
      form: 'form',
      body: {
        showCancel: true,
        showComfirm: true,
        nameCancel: 'Cancelar',
        nameComfirm: 'Guardar'
      }
    },
    MainMessageDialog: {
      with: 500,
      dialog: false,
      title: '',
      description: '',
      subdescription: '',
      icon: '',
      image: '',
      body: {
        showCancel: true,
        showComfirm: true,
        nameCancel: 'Cancelar',
        nameComfirm: 'Guardar'
      }
    },
    MainProgressDialog: {
      with: 600,
      dialog: false,
      title: '',
      icon: '',
      progress: 'circular'
    },
    ResponseDataDialog: {}
  },
  getters: {
    get_MainFormDialog (state) { return state.MainFormDialog },
    get_MainMessageDialog (state) { return state.MainMessageDialog },
    get_MainProgressDialog (state) { return state.MainProgressDialog },
    get_ResponseDataDialog (state) { return state.ResponseDataDialog }
  },
  mutations: {
    SHOW_MAIN_FORM_DIALOG (state, payload) {
      state.MainFormDialog = {
        icon: payload.icon,
        identity: payload.identity,
        with: (payload.with) ? payload.with : '500',
        dialog: true,
        title: payload.title,
        body: payload.body,
        returned: payload.returned
      }
    },
    HIDDEN_MAIN_FORM_DIALOG (state, payload) {
      state.MainFormDialog = {
        icon: '',
        identity: '',
        with: 600,
        dialog: false,
        title: '',
        form: 'form',
        body: {
          showCancel: true,
          showComfirm: true,
          nameCancel: 'Cancelar',
          nameComfirm: 'Guardar'
        }
      }
    },

    SHOW_MAIN_MESSAGE_DIALOG (state, payload) {
      state.MainMessageDialog = {
        identity: payload.identity,
        with: (payload.with) ? payload.with : '500',
        dialog: true,
        title: payload.title,
        description: payload.description,
        subdescription: payload.subdescription,
        icon: payload.icon,
        image: (payload.image) ? payload.image : null,
        body: payload.body
      }
    },
    HIDDEN_MAIN_MESSAGE_DIALOG (state, payload) {
      state.MainMessageDialog = {
        identity: '',
        with: '500',
        dialog: false,
        title: '',
        description: '',
        subdescription: '',
        icon: '',
        image: '',
        body: {
          showCancel: true,
          showComfirm: true,
          nameCancel: 'Cancelar',
          nameComfirm: 'Guardar'
        }
      }
    },

    SHOW_MAIN_PROGRESS_DIALOG (state, payload) {
      state.MainProgressDialog = {
        with: payload.with ? payload.with : '600',
        dialog: true,
        title: payload.title,
        icon: payload.icon ? payload.icon : '$vuetify-outline',
        progress: payload.progress ? payload.progress : 'circular'
      }
    },
    HIDDEN_MAIN_PROGRESS_DIALOG (state, payload) {
      state.MainProgressDialog = {
        with: '600',
        dialog: false,
        title: '',
        icon: '',
        progress: 'circular'
      }
    },

    RESPONSE_DATA_DIALOG (state, payload) {
      state.ResponseDataDialog = payload
    }
  }
})
